import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AppHeaderModule } from 'shared/header/header.module';
import { TabsModule } from 'shared/tabs/tabs.module';
import { DropdownModule } from 'shared/dropdown/dropdown.module';
import { AccountModule } from 'shared/account/account.module';
import { IconModule } from 'shared/icon/icon.module';
import { PaginationModule } from 'shared/pagination/pagination.module';
import { SearchModule } from 'shared/search/search.module';

import { SearchPageService } from './search-page.service';

import { SearchPageComponent } from './search-page.component';
import { SearchPageSimpleHeaderComponent } from './search-page-simple-header/search-page-simple-header.component';
import { AlertsModule } from 'shared/alerts/alerts.module';


@NgModule({
  imports: [
    CommonModule,
    AppHeaderModule,
    TabsModule,
    DropdownModule,
    AccountModule,
    IconModule,
    PaginationModule,
    SearchModule,
    AlertsModule,
  ],
  declarations: [
    SearchPageComponent,
    SearchPageSimpleHeaderComponent,
  ],
  exports: [
    SearchPageComponent,
    SearchPageSimpleHeaderComponent,
  ],
  providers: [SearchPageService]
})
export class SearchPageModule {}
